import { action, makeObservable, observable } from "mobx";
import { Patient } from "../models";

class PatientStore {
  @observable currentPatient: Partial<Patient> = {
    first_name: "",
    last_name: "",
    id: "",
    dob: "",
    contact_number: "",
    is_new_pt: "unknown", 
    last_seen_did: null, 
  };

  @observable currentMainLoginPatient: Partial<Patient> = {
    first_name: "",
    last_name: "",
    id: "",
    dob: "",
    contact_number: "",
    is_new_pt: "unknown", 
    last_seen_did: null, 
  };

  constructor() {
    makeObservable(this);
  }

  @action
  setCurrentPatient = (patient: Patient) => {
    this.currentPatient = patient;
  };

  @action
  setPatientId = (patientId: string) => {
    this.currentPatient.id = patientId;
  };

  @action
  setMainLoginPatient = (patient: Patient) => {
    this.currentMainLoginPatient = patient;
  };
}

export const patientStore = new PatientStore();
